import { Modal } from "@mui/material";
import { CommonBatchBrandForm } from "../../components/brand-batch/brand-batch-form";
import ModalBox from "../../components/common/modal";
import { Batch } from "../playground/types";

export const BatchEdit: React.FC<{
  onClose: () => void;
  batchId: string;
  batchData: Batch;
}> = ({ onClose, batchId, batchData }) => {
  return (
    <Modal open={true} onClose={onClose} aria-labelledby="batch-modal">
      <ModalBox title={`Edit Batch ${batchData.name}`}>
        <CommonBatchBrandForm
          onClose={onClose}
          type="batch"
          id={batchId}
          data={batchData}
        />
      </ModalBox>
    </Modal>
  );
};
